import { render, staticRenderFns } from "./glBreadcrumb.vue?vue&type=template&id=2340f6ba&scoped=true"
import script from "./glBreadcrumb.vue?vue&type=script&lang=js"
export * from "./glBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./glBreadcrumb.vue?vue&type=style&index=0&id=2340f6ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2340f6ba",
  null
  
)

export default component.exports